import React, { useContext, useEffect, useState } from "react";
import { HomePageContext } from "../../store/HomePageContext";
import styles from "./CourseCategories.module.css";
import { Link, useNavigate } from "react-router-dom";
import axios from "axios";
import { LanguageContext } from "../../Component/LanguageContext/LanguageContext";
const marketingBackendUrl = import.meta.env.VITE_MARKETING_BACKEND_URL;
const CourseCategories = () => {
  const { homeScreenDetails, loading, error } = useContext(HomePageContext);
  const { direction } = useContext(LanguageContext);
  const [courses, setCourses] = useState([]);
  const [fetchError, setFetchError] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchCourses = async () => {
      try {
        const response = await axios.get(
          `${marketingBackendUrl}/maflam/specialized-courses`
        );

        setCourses(response.data);
      } catch (err) {
        console.error("Failed to fetch courses:", err);
        setFetchError("Failed to fetch courses");
      }
    };

    fetchCourses();
  }, []);

  const handleCourseClick = (redirectionLink) => {
    navigate(redirectionLink);
  };

  if (loading) {
    return <p>Loading...</p>;
  }

  if (error || fetchError) {
    return <p>Error loading courses: {error?.message || fetchError}</p>;
  }

  return (
    <div className={styles.courseContainer}>
      <div className={styles.coursesContainer}>
        <h2
          style={{
            fontSize: "36px",
          }}
        >
          {homeScreenDetails?.specializedCoursesDataTitle?.title ||
            "Specialized Courses"}
        </h2>
        <div className={styles.coursesGrid}>
          {courses.map((course, index) => (
            <div
              key={index}
              className={styles.coursesCard}
              style={{
                overflow: "hidden",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <Link
                style={{ width: "100%", height: "100%" }}
                to="#"
                onClick={() => handleCourseClick(course.redirectionLink)}
              >
                <img
                  style={{
                    width: "100%",
                    backgroundColor: "color",
                    backgroundPosition: "center",
                    position: "absolute",
                    bottom: "0px",
                    left: "0px",
                  }}
                  src={course.thumbnailUrl}
                  alt={
                    direction === "rtl"
                      ? course.courseNameArab
                      : course.courseNameEng
                  }
                />
              </Link>
              <div
                style={{
                  position: "absolute",
                  bottom: "10px",
                  zIndex: "10",
                  fontSize: "36px",
                }}
              >
                <p>
                  <Link
                    to={course.redirectionLink}
                    onClick={() => handleCourseClick(course.redirectionLink)}
                  >
                    {direction === "rtl"
                      ? course.courseNameArab
                      : course.courseNameEng}
                  </Link>
                </p>
              </div>
              <div className={styles.overlay}></div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default CourseCategories;
